import { ComponentProps, ReactNode } from "react"
import { ReceiptUpperLimitManagementItem } from "../../../../types"
import { t } from "i18next"

export type Row = {
  line_no: number | string
  facility_number: string
  facility_name: string
  total_amount: number | string
  burden_amount: number | string
  management_result_burden_amount: number | string
}

export const TABLE_HEADS = [
  {
    // 項番
    key: "1",
    title: t("S.N"),
  },
  {
    // 事業所番号
    key: "3",
    // TODO: translate
    title: "事業所番号",
  },
  {
    // 事業所名称
    key: "4",
    title: t("Business official name"),
  },
  {
    // 総費用額
    key: "5",
    // TODO: translate
    title: "総費用額",
  },
  {
    // 利用者負担額
    key: "6",
    title: t("User’s burden amount"),
  },
  {
    // 管理結果後利用者負担額
    key: "7",
    title: t("User burden after management results"),
  },
]

type ContentProps = {
  data: string
} & ComponentProps<"div">

export function Content({ data = "", ...props }: ContentProps) {
  return (
    <div className={"facility_total_amount"} {...props}>
      {data.split("")?.map((v, index) => (
        <div key={index} className={"value"}>
          {v !== "." ? v : ""}
        </div>
      ))}
    </div>
  )
}

export type TableColumn = {
  title?: number
  align?: "left" | "center" | "right"
  width?: number
  render: (
    row: ReceiptUpperLimitManagementItem,
    header: { key: number; title: string },
    title: number
  ) => ReactNode
}

export function generateDynamicColumn(facilities: Row[]): any[] {
  const columns: TableColumn[] = []
  facilities.map((value) => {
    columns.push({
      width: 180,
      align: "center",
      render: (_, __, idx) => {
        return getColumnInfo(value, idx)
      },
    })
  })

  return columns
}

export function getColumnInfo(row: Row, index: number) {
  // 項番
  if (index === 0) {
    return row.line_no
  }
  // 事業所番号
  if (index === 1) {
    return row.facility_number
  }
  // 事業所名
  if (index === 2) {
    return row.facility_name
  }
  // 合計金額
  if (index === 3) {
    return <Content data={String(row.total_amount ?? "").padStart(6, ".")} />
  }
  // 利用者負担額
  if (index === 4) {
    return <Content data={String(row.burden_amount ?? "").padStart(6, ".")} />
  }
  // 管理結果後利用者負担額
  if (index === 5) {
    return (
      <Content
        data={String(row.management_result_burden_amount ?? "").padStart(
          6,
          "."
        )}
      />
    )
  }
  return ""
}

export function getTotalColumnInfo(
  totalAmount: number,
  totalBurdenAmount: number,
  managementResultBurdenAmount: number,
  index: number
) {
  if (index === 0) {
    return t("Total")
  }
  if (index === 3) {
    return <Content data={String(totalAmount ?? "").padStart(6, ".")} />
  }
  if (index === 4) {
    return <Content data={String(totalBurdenAmount ?? "").padStart(6, ".")} />
  }
  if (index === 5) {
    return (
      <Content
        data={String(managementResultBurdenAmount ?? "").padStart(6, ".")}
      />
    )
  }
  return ""
}

export function padEmptyFacilities(facilities: Row[], length: number) {
  let count = length - facilities.length
  if (length <= 0) {
    return facilities
  }
  while (count > 0) {
    facilities.push({
      line_no: "",
      facility_number: "",
      facility_name: "",
      total_amount: "",
      burden_amount: "",
      management_result_burden_amount: "",
    })
    count--
  }
  return facilities
}

export function makeEmptyCell(length: number) {
  return (
    <div className={"facility_total_amount"}>
      {Array(length)
        .fill(" ")
        .map((v, index) => (
          <div key={index} className={"value"}>
            {v !== "." ? v : ""}
          </div>
        ))}
    </div>
  )
}

export function makeEmptyRowData() {
  return {
    line_no: "",
    facility_number: "",
    facility_name: "",
    total_amount: "",
    insurance_amount: "",
    burden_amount: "",
    management_result_burden_amount: "",
    management_result_insurance_amount: "",
    local_exemption: "",
    local_burden_amount: "",
  }
}
